import { Invitation } from 'services/api/invitations/types';
import { formatDate } from 'utils/date';
import { TextContentType } from 'utils/text/renderTextContent';

export function formatInvitationToEquipmentListGrantedAccessI18nKey({
  accessDetails,
  sharedItemDetails,
}: Invitation): TextContentType {
  return {
    i18nKey: `access_sharing.equipment_list.invitations.${
      accessDetails.startsAt ? 'granted_access_to_from' : 'granted_access_to'
    }`,
    values: {
      name: sharedItemDetails.ownerName,
      to: sharedItemDetails.sharedItemLabel,
      date: formatDate(accessDetails.startsAt, 'DATE_FORMAT_READABLE'),
    },
  };
}
